import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import './style.css';

export default React.memo(function Docs(){

    /*
            Another way for use the github markdown but the not parse the html properly.
            => https://raw.githubusercontent.com/suryapratapsinghsuryavanshi/solverjs/main/README.md
    */

    const [markdown, setMarkdown] = useState({});
    const [loading, setLoadingn] = useState(true);
    
    useEffect(() => {
        axios.get('https://api.npms.io/v2/package/solverjs')
        .then(data => {
            setMarkdown(data.data["collected"]["metadata"]["readme"]);
            setLoadingn(false);
        })
        .catch(err => {
            console.log(err);
        });
    }, [])

    if(loading){
        return(
            <React.Fragment>
                <div className="markdown">
                    <h2 className="load">Please wait for the data to load.</h2>
                </div>
            </React.Fragment>
        );
    }else{
        return(
            <React.Fragment>
                <div className="markdown">
                    <ReactMarkdown children={markdown.toString()} remarkPlugins={[remarkGfm]} />
                </div>
            </React.Fragment>
        );
    }
});